

import appsettings from '@/store/app-settings'
import {axiosGet, axiosPost}  from '@/store/api/axiosUtils.js'

const getLeaderList = (params) => {
    // const data = {
    //     params
    // }
    return axiosGet(appsettings.ocpbComplaintAPIUrl + 'api/LeaderDept/GetLeaderList', params)
}

export {getLeaderList}